export default class BankIdEntity {

  constructor (
    sessionId,
    redirectUrl,
    autostart
  ) {
    this.sessionId = sessionId;
    this.redirectUrl = redirectUrl;
    this.autostart = autostart;
  }
}



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/bank-id/bank-id-entity.js
 **/